"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _NavMarker = _interopRequireDefault(require("react-rhumb/NavMarker"));

var _immutable = _interopRequireDefault(require("immutable"));

var _underscore = require("underscore");

var _GoodFiltersAndPage = _interopRequireDefault(require("../../constants/GoodFiltersAndPage"));

var _InitialFilterParams = _interopRequireDefault(require("../../constants/InitialFilterParams"));

var _langUtils = require("../../utils/langUtils");

var _utils = require("../../utils/utils");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _UIRouterLink = _interopRequireDefault(require("ui-addon-react-router/UIRouterLink"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIModalDialog = _interopRequireDefault(require("UIComponents/dialog/UIModalDialog"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UILoadingOverlay = _interopRequireDefault(require("UIComponents/loading/UILoadingOverlay"));

var _UIBackButton = _interopRequireDefault(require("UIComponents/nav/UIBackButton"));

var _UITab = _interopRequireDefault(require("UIComponents/nav/UITab"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _Carousel = _interopRequireDefault(require("marketplace-lib/components/carousel/Carousel"));

var _withPartials = _interopRequireDefault(require("marketplace-lib/components/hocs/withPartials"));

var _GoodInfoCard = _interopRequireDefault(require("./GoodInfoCard"));

var _GoodRatingInfo = _interopRequireDefault(require("./GoodRatingInfo"));

var _PackContents = _interopRequireDefault(require("./PackContents"));

var _TrialBanner = _interopRequireDefault(require("./TrialBanner"));

var _FilterRouterLink = _interopRequireDefault(require("../FilterRouterLink"));

var _PurchaseButtonContainer = _interopRequireDefault(require("../../containers/PurchaseButtonContainer"));

var _ReviewListContainer = _interopRequireDefault(require("../../containers/ReviewListContainer"));

var _ReviewModalContainer = _interopRequireDefault(require("../../containers/ReviewModalContainer"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var getI18nKey = (0, _underscore.memoize)(function (path) {
  return "MarketplaceUI.goodDetailsPage." + path;
});
var TabIds = Object.freeze((0, _keyMirror.default)({
  DETAILS: null,
  REVIEWS: null
}));
var CAROUSEL_THUMBNAIL_HEIGHT = 80;
var MAIN_CONTENT_SIZE = 8;

var MainColumn = function MainColumn(props) {
  return _react.default.createElement(_UIGridItem.default, (0, _extends2.default)({}, props, {
    size: {
      xs: MAIN_CONTENT_SIZE
    }
  }));
};

var SidebarColumn = function SidebarColumn(props) {
  return _react.default.createElement(_UIGridItem.default, (0, _extends2.default)({}, props, {
    size: {
      xs: 12 - MAIN_CONTENT_SIZE
    }
  }));
};

var GoodDetailsPage =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(GoodDetailsPage, _PureComponent);

  function GoodDetailsPage(props) {
    var _this;

    (0, _classCallCheck2.default)(this, GoodDetailsPage);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(GoodDetailsPage).call(this, props));
    _this.getDefaultFilters = _this.getDefaultFilters.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleTabChange = _this.handleTabChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleTriggerReview = _this.handleTriggerReview.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      selectedTabId: TabIds.DETAILS
    };
    return _this;
  }

  (0, _createClass2.default)(GoodDetailsPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          canReview = _this$props.canReview,
          navigateFromGoodDetailsReview = _this$props.navigateFromGoodDetailsReview,
          reviewMode = _this$props.reviewMode;

      if (reviewMode) {
        if (canReview) {
          this.handleTriggerReview();
        } else {
          navigateFromGoodDetailsReview();
        }
      }
    }
  }, {
    key: "getDefaultFilters",
    value: function getDefaultFilters() {
      var goodDetails = this.props.goodDetails;
      return _InitialFilterParams.default.merge((0, _defineProperty2.default)({}, _GoodFiltersAndPage.default.SUB_TYPE, goodDetails.get('subType')));
    }
  }, {
    key: "handleTabChange",
    value: function handleTabChange(event) {
      this.setState({
        selectedTabId: event.target.value
      });
    }
  }, {
    key: "handleTriggerReview",
    value: function handleTriggerReview() {
      var _this$props2 = this.props,
          goodDetails = _this$props2.goodDetails,
          triggerReviewModal = _this$props2.triggerReviewModal;
      triggerReviewModal(goodDetails.get('goodId'), goodDetails.get('goodName'), goodDetails.get('transactionId'));
    }
  }, {
    key: "renderBackLink",
    value: function renderBackLink() {
      var _this$props3 = this.props,
          goodFiltersAndPage = _this$props3.goodFiltersAndPage,
          previewMode = _this$props3.previewMode,
          redirectUrl = _this$props3.redirectUrl;
      var Link = redirectUrl ? _UILink.default : _UIRouterLink.default;
      var linkProps = redirectUrl ? {
        href: redirectUrl
      } : {
        to: (0, _utils.getUrlWithNonInitialFiltersAndPageShown)(goodFiltersAndPage)
      };
      return _react.default.createElement(_UIBackButton.default, {
        className: "integrate-back-to-products"
      }, _react.default.createElement(Link, (0, _extends2.default)({
        disabled: previewMode
      }, linkProps), _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('backLink')
      })));
    }
  }, {
    key: "renderRatingInfo",
    value: function renderRatingInfo() {
      var goodDetails = this.props.goodDetails;
      return _react.default.createElement(_GoodRatingInfo.default, {
        goodDetails: goodDetails
      });
    }
  }, {
    key: "renderProviderInfo",
    value: function renderProviderInfo() {
      var _this$props4 = this.props,
          goodDetails = _this$props4.goodDetails,
          previewMode = _this$props4.previewMode;
      var providerName = goodDetails.get('providerName');
      return _react.default.createElement(_FormattedReactMessage.default, {
        message: getI18nKey('header.provider'),
        options: {
          providerLink: _react.default.createElement(_FilterRouterLink.default, {
            disabled: previewMode,
            filters: _InitialFilterParams.default.merge((0, _defineProperty2.default)({}, _GoodFiltersAndPage.default.PROVIDER, providerName))
          }, providerName)
        }
      });
    }
  }, {
    key: "renderPreviewButton",
    value: function renderPreviewButton() {
      var _this$props5 = this.props,
          goodDetails = _this$props5.goodDetails,
          isCustomModule = _this$props5.isCustomModule,
          partial = _this$props5.partial,
          previewMode = _this$props5.previewMode,
          trackLinkClick = _this$props5.trackLinkClick;

      if (!isCustomModule && goodDetails.get('exampleLink')) {
        return _react.default.createElement(_UIButton.default, {
          disabled: previewMode,
          external: true,
          href: goodDetails.get('exampleLink'),
          onClick: partial(trackLinkClick, 'liveExampleButton'),
          use: "secondary"
        }, _react.default.createElement(_FormattedMessage.default, {
          message: getI18nKey('previewButton.liveExample')
        }));
      }

      return null;
    }
  }, {
    key: "renderPurchaseButton",
    value: function renderPurchaseButton() {
      var _this$props6 = this.props,
          goodNameUrlToken = _this$props6.goodNameUrlToken,
          previewMode = _this$props6.previewMode,
          providerUrlToken = _this$props6.providerUrlToken;
      return _react.default.createElement(_PurchaseButtonContainer.default, {
        goodNameUrlToken: goodNameUrlToken,
        previewMode: previewMode,
        providerUrlToken: providerUrlToken
      });
    }
  }, {
    key: "renderConnectButton",
    value: function renderConnectButton() {
      var goodDetails = this.props.goodDetails;
      return _react.default.createElement(_UIButton.default, {
        className: "purchase-button integrate-purchase-button",
        use: "primary",
        external: true,
        href: goodDetails.get('exampleLink')
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('connectButton.buttonText')
      }));
    }
  }, {
    key: "renderCtaBanner",
    value: function renderCtaBanner() {
      var _this$props7 = this.props,
          canTrialMarketing = _this$props7.canTrialMarketing,
          goodDetails = _this$props7.goodDetails,
          hasPurchaseAccess = _this$props7.hasPurchaseAccess,
          isCustomer = _this$props7.isCustomer,
          partial = _this$props7.partial,
          trackLinkClick = _this$props7.trackLinkClick;

      if (isCustomer && hasPurchaseAccess) {
        return null;
      }

      if (canTrialMarketing || !isCustomer) {
        return _react.default.createElement(_TrialBanner.default, {
          canTrialMarketing: canTrialMarketing,
          isCustomer: isCustomer,
          partial: partial,
          trackLinkClick: trackLinkClick,
          urlToken: goodDetails.get('urlToken')
        });
      }

      return null;
    }
  }, {
    key: "renderInfoCard",
    value: function renderInfoCard() {
      var _this$props8 = this.props,
          goodDetails = _this$props8.goodDetails,
          isCustomModule = _this$props8.isCustomModule,
          isEmailTemplate = _this$props8.isEmailTemplate,
          isPack = _this$props8.isPack,
          isTemplate = _this$props8.isTemplate,
          previewMode = _this$props8.previewMode,
          trackLinkClick = _this$props8.trackLinkClick;
      return _react.default.createElement(_GoodInfoCard.default, {
        defaultFilters: this.getDefaultFilters(),
        goodDetails: goodDetails,
        isCustomModule: isCustomModule,
        isEmailTemplate: isEmailTemplate,
        isPack: isPack,
        isTemplate: isTemplate,
        previewMode: previewMode,
        trackLinkClick: trackLinkClick
      });
    }
  }, {
    key: "renderTabsCard",
    value: function renderTabsCard() {
      var goodDetails = this.props.goodDetails;
      var selectedTabId = this.state.selectedTabId;
      return _react.default.createElement(_UICardWrapper.default, null, _react.default.createElement(_UITabs.default, {
        onSelectedChange: this.handleTabChange,
        selected: selectedTabId
      }, _react.default.createElement(_UITab.default, {
        tabId: TabIds.DETAILS,
        title: _react.default.createElement(_FormattedMessage.default, {
          message: getI18nKey('details.title')
        })
      }, _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: goodDetails.get('description')
        }
      })), _react.default.createElement(_UITab.default, {
        tabId: TabIds.REVIEWS,
        title: this.renderRatingInfo()
      }, _react.default.createElement(_ReviewListContainer.default, {
        triggerReviewModal: this.handleTriggerReview
      }))));
    }
  }, {
    key: "renderTabsSectionContent",
    value: function renderTabsSectionContent() {
      var selectedTabId = this.state.selectedTabId;
      var renderedTabsCard = this.renderTabsCard();

      if (selectedTabId === TabIds.REVIEWS) {
        return renderedTabsCard;
      }

      return _react.default.createElement(_UIGrid.default, null, _react.default.createElement(MainColumn, null, renderedTabsCard), _react.default.createElement(SidebarColumn, null));
    }
  }, {
    key: "renderMainCarouselContent",
    value: function renderMainCarouselContent(props) {
      var className = props.className,
          children = props.children;
      return _react.default.createElement(_UICardWrapper.default, {
        className: className,
        compact: true
      }, children);
    }
  }, {
    key: "renderCarousel",
    value: function renderCarousel() {
      var goodDetails = this.props.goodDetails;
      var moduleImages = goodDetails.get('customModuleImages').toArray();

      if (!moduleImages.length) {
        moduleImages = [goodDetails.get('smallImageUrl')];
      }

      return _react.default.createElement("div", {
        className: "flex-grow-1",
        "data-test-id": "module-image-carousel"
      }, _react.default.createElement(_Carousel.default, {
        imageUrls: moduleImages,
        mainComponent: this.renderMainCarouselContent,
        thumbnailHeight: CAROUSEL_THUMBNAIL_HEIGHT
      }));
    }
  }, {
    key: "renderPackContents",
    value: function renderPackContents() {
      var _this$props9 = this.props,
          goodDetails = _this$props9.goodDetails,
          packChildrenSubTypes = _this$props9.packChildrenSubTypes,
          previewMode = _this$props9.previewMode,
          trackLinkClick = _this$props9.trackLinkClick;
      return _react.default.createElement(_PackContents.default, {
        goodDetails: goodDetails,
        packChildrenSubTypes: packChildrenSubTypes,
        previewMode: previewMode,
        trackLinkClick: trackLinkClick
      });
    }
  }, {
    key: "renderTemplateImage",
    value: function renderTemplateImage() {
      var _this$props10 = this.props,
          goodDetails = _this$props10.goodDetails,
          partial = _this$props10.partial,
          previewMode = _this$props10.previewMode,
          trackLinkClick = _this$props10.trackLinkClick;

      var renderedImage = _react.default.createElement(_UIImage.default, {
        className: "integrate-template-image",
        src: goodDetails.get('imageUrl')
      });

      if (!previewMode) {
        renderedImage = _react.default.createElement(_UILink.default, {
          external: true,
          href: goodDetails.get('exampleLink'),
          iconProps: {
            className: 'hidden'
          },
          onClick: partial(trackLinkClick, 'screenshot')
        }, renderedImage);
      }

      return _react.default.createElement("div", {
        className: "template-image-relative-wrapper",
        "data-test-id": "template-image"
      }, _react.default.createElement("div", {
        className: "template-image-container"
      }, renderedImage));
    }
  }, {
    key: "renderMainContent",
    value: function renderMainContent() {
      var _this$props11 = this.props,
          isCustomModule = _this$props11.isCustomModule,
          isPack = _this$props11.isPack,
          isTemplate = _this$props11.isTemplate;

      if (isCustomModule) {
        return this.renderCarousel();
      }

      if (isPack) {
        return this.renderPackContents();
      }

      if (isTemplate) {
        return this.renderTemplateImage();
      }

      return null;
    }
  }, {
    key: "renderErrorModalIfPurchaseError",
    value: function renderErrorModalIfPurchaseError() {
      var _this$props12 = this.props,
          goodDetails = _this$props12.goodDetails,
          onClickPurchaseErrorModalClose = _this$props12.onClickPurchaseErrorModalClose;
      return goodDetails.get('purchaseError') && _react.default.createElement(_UIModalDialog.default, {
        width: 350
      }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
        onClick: onClickPurchaseErrorModalClose
      }), _react.default.createElement(_H.default, {
        className: "m-all-0"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: (0, _langUtils.getPurchaseErrorHeaderKey)(goodDetails.get('purchaseError'))
      }))), _react.default.createElement(_UIDialogBody.default, null, _react.default.createElement(_FormattedMessage.default, {
        message: (0, _langUtils.getPurchaseErrorMessageKey)(goodDetails.get('purchaseError'))
      })), _react.default.createElement(_UIDialogFooter.default, null, _react.default.createElement(_UIButton.default, {
        onClick: onClickPurchaseErrorModalClose,
        use: "primary"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('purchaseErrorModal.button')
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props13 = this.props,
          goodDetails = _this$props13.goodDetails,
          isCustomModule = _this$props13.isCustomModule,
          isPack = _this$props13.isPack,
          isTemplate = _this$props13.isTemplate,
          previewMode = _this$props13.previewMode;
      var containerClasses = (0, _classnames.default)('details-container', {
        'is--module': isCustomModule,
        'is--pack': isPack,
        'is--template': isTemplate
      });
      return _react.default.createElement("div", {
        className: "details-page"
      }, _react.default.createElement(_NavMarker.default, {
        name: "DETAIL_PAGE_LOAD"
      }), previewMode && _react.default.createElement(_NavMarker.default, {
        name: "DETAIL_PREVIEW_BANNER_LOAD"
      }, _react.default.createElement(_UIAlert.default, {
        "data-test-id": "preview-mode-banner",
        type: "info"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('previewModeBanner')
      }))), _react.default.createElement("div", {
        className: containerClasses
      }, goodDetails.get('purchaseInProcess') && _react.default.createElement(_UILoadingOverlay.default, null), _react.default.createElement(_UIFlex.default, {
        className: "page-content-wrapper",
        justify: "center"
      }, _react.default.createElement("div", {
        className: "fixed-page-content"
      }, _react.default.createElement(_UISection.default, null, this.renderBackLink()), _react.default.createElement(_UISection.default, null, _react.default.createElement(_UIFlex.default, {
        align: "baseline",
        justify: "between",
        wrap: "wrap"
      }, _react.default.createElement(_UIBox.default, {
        grow: 1,
        shrink: 1
      }, _react.default.createElement(_UIFlex.default, {
        align: "baseline",
        className: "m-bottom-4"
      }, _react.default.createElement("h4", {
        className: "m-bottom-0"
      }, goodDetails.get('goodName')), this.renderRatingInfo()), this.renderProviderInfo()), _react.default.createElement(_UIBox.default, {
        grow: 0,
        shrink: 0
      }, _react.default.createElement(_UIFlex.default, {
        wrap: "wrap"
      }, this.renderPreviewButton(), _react.default.createElement("div", {
        className: "m-left-2"
      }, this.renderPurchaseButton()))))), this.renderCtaBanner(), _react.default.createElement(_UISection.default, null, _react.default.createElement(_UIGrid.default, null, _react.default.createElement(MainColumn, {
        className: "good-details__main-content"
      }, this.renderMainContent()), _react.default.createElement(SidebarColumn, null, this.renderInfoCard()))), _react.default.createElement(_UISection.default, null, this.renderTabsSectionContent())))), _react.default.createElement(_ReviewModalContainer.default, {
        pageOpenedFrom: "details"
      }), this.renderErrorModalIfPurchaseError());
    }
  }]);
  return GoodDetailsPage;
}(_react.PureComponent);

GoodDetailsPage.propTypes = {
  canReview: _propTypes.default.bool.isRequired,
  canTrialMarketing: _propTypes.default.bool.isRequired,
  goodDetails: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  goodFiltersAndPage: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  goodNameUrlToken: _propTypes.default.string.isRequired,
  hasPurchaseAccess: _propTypes.default.bool.isRequired,
  isCustomModule: _propTypes.default.bool.isRequired,
  isCustomer: _propTypes.default.bool.isRequired,
  isEmailTemplate: _propTypes.default.bool.isRequired,
  isPack: _propTypes.default.bool.isRequired,
  isTemplate: _propTypes.default.bool.isRequired,
  navigateFromGoodDetailsReview: _propTypes.default.func.isRequired,
  onClickPurchaseErrorModalClose: _propTypes.default.func.isRequired,
  packChildrenSubTypes: _propTypes.default.arrayOf(_propTypes.default.string),
  partial: _propTypes.default.func.isRequired,
  previewMode: _propTypes.default.bool.isRequired,
  providerUrlToken: _propTypes.default.string.isRequired,
  reviewMode: _propTypes.default.bool.isRequired,
  redirectUrl: _propTypes.default.string,
  trackLinkClick: _propTypes.default.func.isRequired,
  triggerReviewModal: _propTypes.default.func.isRequired
};
GoodDetailsPage.defaultProps = {
  previewMode: false,
  reviewMode: false
};

var _default = (0, _withPartials.default)(GoodDetailsPage);

exports.default = _default;
module.exports = exports.default;